

































import { Component, Vue } from "vue-property-decorator";
import SubcontractorList from "@/components/admin/list/SubcontractorList.vue";
@Component({
  components: { SubcontractorList }
})
export default class extends Vue {
  public site_id = 0;

  created() {
    this.site_id = Number(this.$route.params.site_id);
  }
}
